import React from 'react'

export const EXPIRED_LINK_MESSAGE = 'This link has expired. Please ask your representative to send a new one.'

const ExpiredLink = ({ message, testId }) => (
  <div className="min-h-screen bg-background flex items-center justify-center p-4"
    data-testid={testId}>
    <div className="border border-divider bg-paper shadow-lg rounded-2xl p-12 text-center max-w-md">
      <div className="text-xl font-bold text-text-primary mb-2">This link has expired</div>
      <div className="text-text-secondary">{message}</div>
    </div>
  </div>
)

export default ExpiredLink
